
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M18.35 4.34995C18.15 4.14995 17.84 4.14995 17.64 4.34995L15.85 6.13995C15.54 6.45995 15.76 6.99995 16.21 6.99995H17V19C17 19.55 17.45 20 18 20C18.55 20 19 19.55 19 19V6.99995H19.79C20.24 6.99995 20.46 6.45995 20.14 6.14995L18.35 4.34995ZM11.8 15.5V10.5L13.4 9.83995C13.76 9.69995 14 9.34995 14 8.95995C14 8.26995 13.29 7.80995 12.66 8.07995L3.69 11.96C3.27 12.13 3 12.54 3 13C3 13.46 3.27 13.87 3.69 14.05L12.66 17.93C13.29 18.2 14 17.73 14 17.04C14 16.65 13.76 16.3 13.4 16.15L11.8 15.5ZM4.98 13L10 11.13V14.87L4.98 13Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-text-rotate-up`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconTextRotateUp

    ```js
    <b-new-b-icon-text-rotate-up />
    ```
</docs>


